import type { MessageKey } from 'types/LocaleMessageKey';

import {
  ONE_YEAR_WARRANTY_SELECTED_SUMMARY_KEY,
  THREE_YEAR_WARRANTY_SELECTED_SUMMARY_KEY,
  TWO_YEAR_WARRANTY_SELECTED_SUMMARY_KEY,
} from '@/app/[locale]/store/_components/HardwarePDP/_hooks/useBuildRingOrder/buildOrderReducer';
import {
  EXTENDED_WARRANTY_2YEAR_SKU,
  EXTENDED_WARRANTY_3YEAR_SKU,
} from '@/app/[locale]/store/_consts';
import WarrantySelectionEnum from '@/app/enums/WarrantySelectionEnum';
import type { RefreshCart_cart_refreshCart_cart_lineItems } from '@/queries/types/RefreshCart';

export interface GetWarrantySelection {
  value: WarrantySelectionEnum;
  sku: string;
  summaryKey: MessageKey;
}

const getWarrantySelection = (
  lineItem: RefreshCart_cart_refreshCart_cart_lineItems | null | undefined,
): GetWarrantySelection => {
  const sku = lineItem?.skuCode ?? '';

  if (sku === EXTENDED_WARRANTY_2YEAR_SKU) {
    return {
      value: WarrantySelectionEnum.TwoYear,
      sku,
      summaryKey: TWO_YEAR_WARRANTY_SELECTED_SUMMARY_KEY,
    };
  } else if (sku === EXTENDED_WARRANTY_3YEAR_SKU) {
    return {
      value: WarrantySelectionEnum.ThreeYear,
      sku,
      summaryKey: THREE_YEAR_WARRANTY_SELECTED_SUMMARY_KEY,
    };
  } else {
    return {
      value: WarrantySelectionEnum.OneYear,
      sku,
      summaryKey: ONE_YEAR_WARRANTY_SELECTED_SUMMARY_KEY,
    };
  }
};

export default getWarrantySelection;
